import { create } from "zustand";

const useAppointmentsStore = create((set) => ({
  appointments: [],
  setAppointments: (appointments) => set({ appointments }),
  clearAppointments: () => set({ appointments: [] }),
}));

export default useAppointmentsStore;